export function sendIdentify(userId, traits) {
  if (!globalThis.analytics) return;

  // Segment shifts args based on typeof userId — passing null/'' here would be
  // mistaken for the traits object and silently drop the real traits. Omit
  // userId entirely when there isn't one; Segment falls back to anonymousId.
  if (userId) {
    // eslint-disable-next-line no-undef
    analytics.identify(userId, traits);
  } else {
    // eslint-disable-next-line no-undef
    analytics.identify(traits);
  }
}

if (typeof globalThis !== 'undefined') {
  globalThis.unlk = globalThis.unlk || {};
  globalThis.unlk.sendIdentify = sendIdentify;
}
